import { useState, useEffect } from 'react';
import { nanoid } from 'nanoid'

export const Phone = () => {

    const [contacts, setContact] = useState([])

    const [filter, setFilter] = useState('')


    useEffect(() => {
        setFilter('')
        if (JSON.parse(localStorage.getItem('Contacts')) === null || undefined || JSON.parse(localStorage.getItem('Contacts')).length === 0) {
            localStorage.setItem('Contacts', JSON.stringify(contacts))
      } else {
            const lcContacts = JSON.parse(localStorage.getItem('Contacts'));
            setContact(lcContacts)
      }
    }, [])

    useEffect(() => {
        console.log(contacts);
        localStorage.setItem('Contacts', JSON.stringify(contacts));
    }, [contacts]);

    const deleteContact = (id) => {
        setContact(contacts.filter(contact => contact.id !== id))
    }

    const addConact = (e) => {
        e.preventDefault();
        let name = e.target.name.value;
        let number = e.target.number.value;
        if (!contacts.some(
        c => c.number === number
        )) {
        const newContact = {
            name: name,
            id: nanoid(),
            number: number
        }

        // this.state.contacts.push(newContact)
        // console.log(this.state)
        setContact(prev => [...prev, newContact]);
        // this.setState(prevState => ({
        //     contacts: [...prevState.contacts, newContact]
        // }));
        } else {
        alert(`You already have a contact with the number of ${number}!`)
        }

    }

    const findContact = (e) => {
        e.preventDefault()
        if (e.target.value === '') {
            setFilter('')
        } else {
            setFilter(e.target.value)
            setContact(contacts.filter((contact) => contact.name.includes(filter)))
        }

        // this.setState({
        // contacts: this.state.contacts.filter((contact) => contact.name.includes(this.state.filter))
        // })
    }
    // const findContact = (e) => {
    //     setFilter(e.target.value);
    // };

    // const filteredContacts = contacts.filter(contact =>
    //     contact.name.toLowerCase().includes((filter || '').toLowerCase())
    // );

    return (
        <div className="Phone">

            <form action="" onSubmit={addConact}>
            <h1>Add Contact</h1>
            <h3>Name</h3>
            <input
                type="text"
                name="name"
                title="Name may contain only letters, apostrophe, dash and spaces. For example Adrian, Jacob Mercer, Charles de Batz de Castelmore d'Artagnan"
                required
            />
            <h3>Number</h3>
            <input
                type="tel"
                name="number"
                title="Phone number must be digits and can contain spaces, dashes, parentheses and can start with +"
                required
            />

            <button type="submit">Add Contact</button>
            </form>


            <form onChange={findContact}>
            <p>Find contacts by name</p>
            <input type="text" />
            </form>

            <div>
            <h2>Contacts</h2>
            <ul style={{ display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center" }}>
                {contacts.map(contact => {
                return <li style={{ display: "flex", alignItems: "center", gap: '20px' }}><p>{contact.name}: <span>{contact.number}</span></p><button onClick={() => deleteContact(contact.id)}>Delete</button></li>
                })}
            </ul>
            </div>

        </div>
    )
}